
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_1elzt_99",
  "box": "awsui_box_18wu0_1elzt_219",
  "p-variant": "awsui_p-variant_18wu0_1elzt_219",
  "color-default": "awsui_color-default_18wu0_1elzt_219",
  "b-variant": "awsui_b-variant_18wu0_1elzt_219",
  "strong-variant": "awsui_strong-variant_18wu0_1elzt_219",
  "code-variant": "awsui_code-variant_18wu0_1elzt_219",
  "pre-variant": "awsui_pre-variant_18wu0_1elzt_219",
  "samp-variant": "awsui_samp-variant_18wu0_1elzt_219",
  "h1-variant": "awsui_h1-variant_18wu0_1elzt_223",
  "h2-variant": "awsui_h2-variant_18wu0_1elzt_223",
  "h3-variant": "awsui_h3-variant_18wu0_1elzt_223",
  "h4-variant": "awsui_h4-variant_18wu0_1elzt_223",
  "h5-variant": "awsui_h5-variant_18wu0_1elzt_223",
  "small-variant": "awsui_small-variant_18wu0_1elzt_227",
  "a-variant": "awsui_a-variant_18wu0_1elzt_231",
  "font-size-default": "awsui_font-size-default_18wu0_1elzt_235",
  "font-weight-default": "awsui_font-weight-default_18wu0_1elzt_275",
  "key-label-variant": "awsui_key-label-variant_18wu0_1elzt_317",
  "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_1elzt_324",
  "value-large-variant": "awsui_value-large-variant_18wu0_1elzt_331",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_1elzt_338",
  "color-inverted": "awsui_color-inverted_18wu0_1elzt_343",
  "color-text-label": "awsui_color-text-label_18wu0_1elzt_346",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_1elzt_349",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_1elzt_352",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_1elzt_355",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_1elzt_358",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_1elzt_361",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_1elzt_364",
  "color-inherit": "awsui_color-inherit_18wu0_1elzt_367",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_1elzt_370",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_1elzt_375",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_1elzt_379",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_1elzt_383",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_1elzt_388",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_1elzt_393",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_1elzt_398",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_1elzt_403",
  "font-weight-light": "awsui_font-weight-light_18wu0_1elzt_408",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_1elzt_411",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_1elzt_414",
  "t-left": "awsui_t-left_18wu0_1elzt_421",
  "t-right": "awsui_t-right_18wu0_1elzt_425",
  "t-center": "awsui_t-center_18wu0_1elzt_429",
  "p-n": "awsui_p-n_18wu0_1elzt_536",
  "p-top-n": "awsui_p-top-n_18wu0_1elzt_541",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_1elzt_542",
  "p-right-n": "awsui_p-right-n_18wu0_1elzt_546",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_1elzt_547",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_1elzt_551",
  "p-left-n": "awsui_p-left-n_18wu0_1elzt_556",
  "p-xxxs": "awsui_p-xxxs_18wu0_1elzt_561",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_1elzt_566",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_1elzt_567",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_1elzt_571",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_1elzt_572",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_1elzt_576",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_1elzt_581",
  "p-xxs": "awsui_p-xxs_18wu0_1elzt_586",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_1elzt_591",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_1elzt_592",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_1elzt_596",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_1elzt_597",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_1elzt_601",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_1elzt_606",
  "p-xs": "awsui_p-xs_18wu0_1elzt_611",
  "p-top-xs": "awsui_p-top-xs_18wu0_1elzt_616",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_1elzt_617",
  "p-right-xs": "awsui_p-right-xs_18wu0_1elzt_621",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_1elzt_622",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_1elzt_626",
  "p-left-xs": "awsui_p-left-xs_18wu0_1elzt_631",
  "p-s": "awsui_p-s_18wu0_1elzt_636",
  "p-top-s": "awsui_p-top-s_18wu0_1elzt_641",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_1elzt_642",
  "p-right-s": "awsui_p-right-s_18wu0_1elzt_646",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_1elzt_647",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_1elzt_651",
  "p-left-s": "awsui_p-left-s_18wu0_1elzt_656",
  "p-m": "awsui_p-m_18wu0_1elzt_661",
  "p-top-m": "awsui_p-top-m_18wu0_1elzt_666",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_1elzt_667",
  "p-right-m": "awsui_p-right-m_18wu0_1elzt_671",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_1elzt_672",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_1elzt_676",
  "p-left-m": "awsui_p-left-m_18wu0_1elzt_681",
  "p-l": "awsui_p-l_18wu0_1elzt_556",
  "p-top-l": "awsui_p-top-l_18wu0_1elzt_691",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_1elzt_692",
  "p-right-l": "awsui_p-right-l_18wu0_1elzt_696",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_1elzt_697",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_1elzt_701",
  "p-left-l": "awsui_p-left-l_18wu0_1elzt_706",
  "p-xl": "awsui_p-xl_18wu0_1elzt_711",
  "p-top-xl": "awsui_p-top-xl_18wu0_1elzt_716",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_1elzt_717",
  "p-right-xl": "awsui_p-right-xl_18wu0_1elzt_721",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_1elzt_722",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_1elzt_726",
  "p-left-xl": "awsui_p-left-xl_18wu0_1elzt_731",
  "p-xxl": "awsui_p-xxl_18wu0_1elzt_736",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_1elzt_741",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_1elzt_742",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_1elzt_746",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_1elzt_747",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_1elzt_751",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_1elzt_756",
  "p-xxxl": "awsui_p-xxxl_18wu0_1elzt_761",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_1elzt_766",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_1elzt_767",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_1elzt_771",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_1elzt_772",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_1elzt_776",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_1elzt_781",
  "m-n": "awsui_m-n_18wu0_1elzt_786",
  "m-top-n": "awsui_m-top-n_18wu0_1elzt_791",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_1elzt_792",
  "m-right-n": "awsui_m-right-n_18wu0_1elzt_796",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_1elzt_797",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_1elzt_801",
  "m-left-n": "awsui_m-left-n_18wu0_1elzt_806",
  "m-xxxs": "awsui_m-xxxs_18wu0_1elzt_811",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_1elzt_816",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_1elzt_817",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_1elzt_821",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_1elzt_822",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_1elzt_826",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_1elzt_831",
  "m-xxs": "awsui_m-xxs_18wu0_1elzt_836",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_1elzt_841",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_1elzt_842",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_1elzt_846",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_1elzt_847",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_1elzt_851",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_1elzt_856",
  "m-xs": "awsui_m-xs_18wu0_1elzt_861",
  "m-top-xs": "awsui_m-top-xs_18wu0_1elzt_866",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_1elzt_867",
  "m-right-xs": "awsui_m-right-xs_18wu0_1elzt_871",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_1elzt_872",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_1elzt_876",
  "m-left-xs": "awsui_m-left-xs_18wu0_1elzt_881",
  "m-s": "awsui_m-s_18wu0_1elzt_886",
  "m-top-s": "awsui_m-top-s_18wu0_1elzt_891",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_1elzt_892",
  "m-right-s": "awsui_m-right-s_18wu0_1elzt_896",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_1elzt_897",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_1elzt_901",
  "m-left-s": "awsui_m-left-s_18wu0_1elzt_906",
  "m-m": "awsui_m-m_18wu0_1elzt_911",
  "m-top-m": "awsui_m-top-m_18wu0_1elzt_916",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_1elzt_917",
  "m-right-m": "awsui_m-right-m_18wu0_1elzt_921",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_1elzt_922",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_1elzt_926",
  "m-left-m": "awsui_m-left-m_18wu0_1elzt_931",
  "m-l": "awsui_m-l_18wu0_1elzt_806",
  "m-top-l": "awsui_m-top-l_18wu0_1elzt_941",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_1elzt_942",
  "m-right-l": "awsui_m-right-l_18wu0_1elzt_946",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_1elzt_947",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_1elzt_951",
  "m-left-l": "awsui_m-left-l_18wu0_1elzt_956",
  "m-xl": "awsui_m-xl_18wu0_1elzt_961",
  "m-top-xl": "awsui_m-top-xl_18wu0_1elzt_966",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_1elzt_967",
  "m-right-xl": "awsui_m-right-xl_18wu0_1elzt_971",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_1elzt_972",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_1elzt_976",
  "m-left-xl": "awsui_m-left-xl_18wu0_1elzt_981",
  "m-xxl": "awsui_m-xxl_18wu0_1elzt_986",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_1elzt_991",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_1elzt_992",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_1elzt_996",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_1elzt_997",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_1elzt_1001",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_1elzt_1006",
  "m-xxxl": "awsui_m-xxxl_18wu0_1elzt_1011",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_1elzt_1016",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_1elzt_1017",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_1elzt_1021",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_1elzt_1022",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_1elzt_1026",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_1elzt_1031",
  "d-block": "awsui_d-block_18wu0_1elzt_1036",
  "d-inline": "awsui_d-inline_18wu0_1elzt_1039",
  "d-inline-block": "awsui_d-inline-block_18wu0_1elzt_1042",
  "d-none": "awsui_d-none_18wu0_1elzt_1045",
  "f-left": "awsui_f-left_18wu0_1elzt_1049",
  "f-right": "awsui_f-right_18wu0_1elzt_1053"
};
  